import config from '../helpers/config-helper';

const appConfig = config();
// const baseURL = appConfig.REACT_APP_PUBLIC_URL;
const baseURL = appConfig.REACT_APP_PUBLIC_URL + '/DIDInnovateHub';
const RoutesConstants = {
  Login: baseURL + '/Login',
  Logout: baseURL + '/Logout',
  AccountActivation: baseURL + '/AccountActivation',
  UserLogs: baseURL + '/UserLogs',
  SystemLogs: baseURL + '/SystemLogs',
};
export default RoutesConstants;
